import AuthService from './AuthService';

const storage = localStorage;

/* eslint-disable */
const hashCode = s =>
  s.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);

    return a & a;
  }, 0);
/* eslint-enable */

let storageKey = null;
const getStorageKey = () => {
  if (!storageKey)
    storageKey = `UserData_${hashCode(`${AuthService.getUserId()};${AuthService.getTenantId()}`)}`;
  return storageKey;
};

const setItem = (key, value) => {
  const userKey = getStorageKey();

  const userData = JSON.parse(storage.getItem(userKey)) || {};
  if (typeof value === 'undefined' || value === null) {
    delete userData[key];
  } else {
    userData[key] = value;
  }
  localStorage.setItem(userKey, JSON.stringify(userData));
};

const getItem = key => {
  const userKey = getStorageKey();
  const userData = JSON.parse(localStorage.getItem(userKey)) || {};
  return userData[key];
};

const userStorage = {
  setItem,
  getItem,
};
export default userStorage;
